import React from 'react';
import { Section } from './ui/Section';
import { Card } from './ui/Card';
import { Quote } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    text: 'Am venit cu anxietate și insomnii. Pentru prima dată am simțit că am un proces clar, nu doar discuții. Azi pot să respir și să iau decizii fără frică.',
    author: 'Maria T.',
    role: 'Antreprenor'
  }, {
    text: 'Mi-a plăcut că a fost și blând, și structurat. M-am simțit în siguranță, dar și ghidat concret. Recomand cu toată încrederea pentru oricine caută profunzime.',
    author: 'Andrei P.',
    role: 'Manager IT'
  }, {
    text: 'Metoda 3S mi-a schimbat perspectiva asupra vieții. Nu mai sunt victima emoțiilor mele, ci am învățat să le înțeleg și să le integrez.',
    author: 'Elena S.',
    role: 'Arhitect'
  }];
  return <Section id="testimoniale" background="default" data-id="element-194">
      <div className="text-center mb-16" data-id="element-195">
        <h2 className="text-3xl md:text-4xl font-bold text-brand-text mb-4" data-id="element-196">
          Ce spun oamenii care au lucrat cu mine
        </h2>
      </div>

      <div className="grid md:grid-cols-3 gap-8" data-id="element-197">
        {testimonials.map((t, i) => <Card key={i} variant="white" className="relative pt-12" data-id="element-198">
            <Quote className="absolute top-6 left-6 w-8 h-8 text-brand-secondary/50 rotate-180" data-id="element-199" />
            <p className="text-gray-600 italic mb-6 relative z-10" data-id="element-200">
              "{t.text}"
            </p>
            <div className="flex items-center" data-id="element-201">
              <div className="w-10 h-10 rounded-full bg-brand-primary/20 flex items-center justify-center text-brand-primary font-bold mr-3" data-id="element-202">
                {t.author.charAt(0)}
              </div>
              <div data-id="element-203">
                <p className="font-bold text-brand-text" data-id="element-204">{t.author}</p>
                <p className="text-xs text-gray-500 uppercase tracking-wide" data-id="element-205">
                  {t.role}
                </p>
              </div>
            </div>
          </Card>)}
      </div>
    </Section>;
}